import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect, useContext } from 'react'
import Modal from 'react-modal';
import { Toast } from 'react-bootstrap';
import EventsService from '../../../services/EventsService';
import { EventModal } from './EventModal';
import ReactQuill from 'react-quill';
import { Context } from '../../..';
import { useNavigate } from 'react-router-dom';
import { ModalPopover } from './modal-popover';
import { modules, formats } from './QuillSettings';
import { MyDocsModal } from './MyDocsModal';

interface ModalProps {
    data: any;
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const EventSettingsModalForSU: FC<ModalProps> = props => {
    const { data, toggle, setToggle } = props;
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const [eventData, setEventData] = useState<any>({...data});
    const [text, setText] = useState('');


    const onRequestClose = () => {
        setToggle(false);
    };

    const getEvent = async () => {
        if (toggle) {
            try {
                const res = await EventsService.getEvent(Number(data.id));
                setEventData(res.data);
            } catch (e) {
                setEventData(data);
            }
        }

    }
    // var htmlObject = document.createElement('div');
    // htmlObject.innerHTML = data['text'];
    useEffect(() => {
        getEvent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toggle]);

    const onChange = (e: React.ChangeEvent<any>) => {
        setEventData({ ...eventData, [e.target.id]: e.target.value });
    };

    const saveEvent = async () => {
        if (eventData.image1.replaceAll(' ', '') !== '') {
            let d: any = {}
            for (let key of Object.keys(eventData)) {
                if (eventData[key] && key !== 'id') {
                    d[key] = eventData[key]
                }
            }

            await EventsService.updateEvent(eventData["id"], d);
            setToggle(false);
        } else {
            alert(store.lang === 'Миниатюраға һылтанманы ҡуйығыҙ' ? 'Эйе' : store.lang === 'ru' ? 'Вставьте ссылку миниатюры' : 'Insert the link of the thumbnail')
        }
    };

    useEffect(() => {
        setEventData({ ...eventData, 'text': text });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text]);

    useEffect(() => {
        if (!store.user.is_staff) {
            navigate('/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store.user.is_staff])

    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <i className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
                <div className="col text-end"><Trans>Configure the event page</Trans></div>
            </div>
            <form className="Modal__Body">
                <div className="row form-group">
                    <div className="col">
                        <div className="row mb-3">
                            <label htmlFor="author" className="col-sm-3 col-form-label"><Trans>Author</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="author" defaultValue={eventData.author} onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="header" className="col-sm-3 col-form-label"><Trans>Header</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="header" defaultValue={eventData.header} onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="text" className="col-sm-3 col-form-label"><Trans>Text</Trans></label>
                            <div className="col-sm-9">
                                {/* <textarea rows={10} className="form-control" id="text" onChange={(e) => onChange(e)} /> */}
                                <ReactQuill
                                    className="EventSettingsQuill"
                                    value={eventData.text}
                                    theme="snow"
                                    modules={modules}
                                    formats={formats}
                                    id="text"
                                    onChange={setText} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <label htmlFor="image1" className="col-sm-3 col-form-label"><Trans>Link of the thumbnail</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image1" defaultValue={eventData.image1} onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image2" className="col-sm-3 col-form-label"><Trans>Link of the 1st photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image2" defaultValue={eventData.image2} onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image3" className="col-sm-3 col-form-label"><Trans>Link of the 2nd photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image3" defaultValue={eventData.image3} onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image4" className="col-sm-3 col-form-label"><Trans>Link of the 3rd photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image4" defaultValue={eventData.image4} onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image5" className="col-sm-3 col-form-label"><Trans>Link of the 4th photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image5" defaultValue={eventData.image5} onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image6" className="col-sm-3 col-form-label"><Trans>Link of the 5th photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image6" defaultValue={eventData.image6} onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image7" className="col-sm-3 col-form-label"><Trans>Link of the 6th photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image7" defaultValue={eventData.image7} onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image8" className="col-sm-3 col-form-label"><Trans>Link of the 7th photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image8" defaultValue={eventData.image8} onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image9" className="col-sm-3 col-form-label"><Trans>Link of the 8th photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image9" defaultValue={eventData.image9} onChange={(e) => onChange(e)} />
                            </div>
                        </div>

                        <button type="button" className="btn btn-success" onClick={() => saveEvent()}><Trans>Save</Trans></button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};